(() => {
  const normalize = (h) => (h || '').toLowerCase().replace(/^www\./, '');

  const internalHosts = new Set(
    (window.__INTERNAL_HOSTS__ || [])
      .filter(Boolean)
      .map(normalize)
  );

  const isExternal = (href) => {
    try {
      const url = new URL(href, window.location.href);
      const host = normalize(url.hostname);

      // Treat any of your Shopify + primary domains as internal
      if (internalHosts.has(host)) return false;

      // Fallback: same-origin is internal
      return url.origin !== window.location.origin;
    } catch {
      return false;
    }
  };

  const shouldIgnore = (href) =>
    !href ||
    href.startsWith('#') ||
    href.startsWith('/#') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:') ||
    href.startsWith('javascript:');

  const tagLink = (a) => {
    const href = a.getAttribute('href') || '';
    if (shouldIgnore(href)) return;

    if (isExternal(href)) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    }
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('a[href]')?.forEach(tagLink);
  };

  document.addEventListener('DOMContentLoaded', () => scan());

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('a[href]')) tagLink(node);
        scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
